import { vars, log } from '../base/variables';

const loadPosts = (wrapper, categories, add, pagenr) => {
    let postsWrapper = wrapper.querySelector('.posts-list-wrapper');
    const nonce = document.getElementById('filter_posts_nonce').getAttribute('value');
    const loadMoreBtn = wrapper.querySelector('.load-more-posts');

    vars.body.classList.add('results-loading');
    vars.body.classList.remove('results-loaded');
    // Ajax
    const xhr = new XMLHttpRequest();
    xhr.open('POST', ferantur_scripts.url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    xhr.onload = function () {
        if (this.status >= 200 && this.status < 400) {
            try {
                var data = JSON.parse(this.response);
                // Successful
            } catch (err) {
                console.log(err.message + " in " + this.response);
                return;
            }
            const markup = data.markup;
            const maxpages = data.maxpages;
            if (loadMoreBtn) {
                if (maxpages > 1 && pagenr < maxpages) {
                    loadMoreBtn.parentNode.style.display = 'inline-block';
                } else {
                    loadMoreBtn.parentNode.style.display = 'none';
                }
                loadMoreBtn.setAttribute('data-maxpages', maxpages);
            }
            if (add != true) {
                postsWrapper.innerHTML = markup;
            } else {
                postsWrapper.innerHTML += markup;
            }
            vars.body.classList.remove('results-loading');
            vars.body.classList.add('results-loaded');
        } else {
            // If fail
            console.log(this.response);
        }
    };
    xhr.onerror = function () {
        console.log('ERROR');
        // Connection error
    };

    xhr.send('action=getPosts&terms=' + categories + '&pagenr=' + pagenr + '&_wpnonce=' + nonce);
}

export { loadPosts };